import React, { useState, useEffect } from "react";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { useDispatch, useSelector } from "react-redux";
import {
  setRegionActions,
  setGeoLoactionStateAction,
} from "../../../Redux/Slice";
import {
  setZoneetrieveAction,
  getZoneCreateActions,
  setZoneEditActions,
} from "../../../Redux/Slice";
import Select from "react-select";
import { data } from "jquery";
import useDebouncedEffect from 'use-debounced-effect';

const ZoneCreate = (props) => {
  const { show, setShow, currentPage, EditId , region, stateID , regionID  , search} = props;
  const state = useSelector((state) => state);
  const initialState = {
    Zone: "",
    description: "",
    region_id: "",
    state_id: "",
  };
  const dispatch = useDispatch();
  const State = useSelector((state) => state);
  const [datas, setDatas] = useState(initialState);
  const [ZoneError, setZoneError] = useState("");
  const [DescriptionError, setDescriptionError] = useState("");
  const [RegionError, setRegionError] = useState("");
  const [multiselect1, setMuliselect1] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  let [nameList, setOptions] = useState([]);
  const [multiselect, setMuliselect] = useState([]);
  const [stateerror, setStateError] = useState("");
  const [states, setState] = useState([]);
  const [SelectRegion, setSlectRegions] = useState([]);
  const [SelectedStates, SetStates] = useState([]);

  const initialStateSearch = {
    stateSearch :"",
    regionSearch:"",
   }
   const [SearchedVal , setSearched] = useState(initialStateSearch)
  
   const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
};

const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);


   useDebouncedEffect(
    () => {
        if (setSearchDebounance) {
            setSearched({
                ...SearchedVal,
                stateSearch: SearchDebounance.stateSearch,
                regionSearch: SearchDebounance.regionSearch,
            });
        }
    },
    500,
    [SearchDebounance]
);

  
 ///-----State----Input Changes
 const handleInputChange = (Val) => {
  setSearchDebounance({
      ...SearchDebounance,
      stateSearch: Val,

  });

};

///---Region-----------------
const HandleRegionChanges = (Val) => {
  setSearchDebounance({
      ...SearchDebounance,
      regionSearch: Val,
  });
};
  useEffect(() => {
    if (EditId != undefined && EditId != "") {
      const payload = {
        EditId: EditId,
      };
      dispatch(setZoneetrieveAction(payload));
      console.log(State.ZoneRetrieve.ZoneRetrieve, "sttaes");
    }
  }, []);
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 10,
      page: currentPage,
    };
    dispatch(setRegionActions(payloads));
    console.log(
      State.regioncall.RegionDat,
      "states",
      State.regioncall.Total_Count
    );
  }, [SearchedVal.regionSearch]);
  useEffect(() => {
    if (datas.state_id != undefined && datas.state_id != "") {
      console.log(datas.state_id, "ppop");
      const payloads = {
        search: SearchedVal.regionSearch,
        page_size: 10,
        page: 1,
        state: datas.state_id,
      };
      dispatch(setRegionActions(payloads));
      setRegion(state.regioncall.RegionDat);
    }
  }, [datas.state_id , SearchedVal.regionSearch]);
  
  //-----States------------------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
    setState(state.GeoState.State);
  }, [SearchedVal.stateSearch]);
  ///------State---datas----------------
  ///--------------------State----------------------
  useEffect(() => {
    const Datas = [];

    setState(state.GeoState.State.state_name);
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      state.GeoState.State.forEach((element) => {
        objectArray.push({ value: element.id, label: element.state_name });
      });

      setOptions(objectArray);
    }
  }, [state.GeoState.State , SearchedVal.stateSearch]);

  //   useEffect(() => {

  //     if (
  //       EditId != undefined &&
  //       EditId != "" &&
  //       State.ZoneRetrieve.ZoneRetrieve.id != undefined && State.ZoneRetrieve.ZoneRetrieve.state_id.id != null
  //       &&  State.ZoneRetrieve.ZoneRetrieve.region_id.id != null ) {
  //       console.log(State.ZoneRetrieve.ZoneRetrieve.state_id.id ,
  //         State.ZoneRetrieve.ZoneRetrieve.region_id.id ,"testinggg");
  //       setDatas({
  //         ...datas,
  //         Zone: State.ZoneRetrieve.ZoneRetrieve.zone_name,
  //         description: State.ZoneRetrieve.ZoneRetrieve.description,
  //         state_id :State.ZoneRetrieve.ZoneRetrieve.state_id.id ,
  // region_id:State.ZoneRetrieve.ZoneRetrieve.region_id.id
  //       });
  //     }
  //   }, [State.ZoneRetrieve.ZoneRetrieve , EditId]);

  useEffect(() => {
    if (
      State.ZoneRetrieve.ZoneRetrieve.id != undefined &&
      State.ZoneRetrieve.ZoneRetrieve.state_id != null &&
      State.ZoneRetrieve.ZoneRetrieve.state_id != undefined
      // State.ZoneRetrieve.ZoneRetrieve.state_id.id != undefined
    ) {
      // console.log(State.ZoneRetrieve.ZoneRetrieve, "editssss");
      let objectState = [];
      objectState.push({
        value: State.ZoneRetrieve.ZoneRetrieve.state_id.id,
        label: State.ZoneRetrieve.ZoneRetrieve.state_id.state_name,
      });
      SetStates(objectState);
      // console.log(SelectedStates, "asfsdf");

      let objectRegion = [];
      objectRegion.push({
        value: State.ZoneRetrieve.ZoneRetrieve.region_id.id,
        label: State.ZoneRetrieve.ZoneRetrieve.region_id.region_name,
      });
      setSlectRegions(objectRegion);
      // console.log(SelectedStates, "popopop");
    }
  }, [State.ZoneRetrieve.ZoneRetrieve]);

  useEffect(() => {
    if (EditId != undefined && EditId != "") {
      setDatas({
        ...datas,
        Zone: State.ZoneRetrieve.ZoneRetrieve.zone_name,
        description: State.ZoneRetrieve.ZoneRetrieve.description,
      });
    }
  }, [State.ZoneRetrieve.ZoneRetrieve.id]);
  useEffect(() => {
    if (
      EditId != undefined &&
      EditId != "" &&
      State.ZoneRetrieve.ZoneRetrieve.id != undefined &&
      State.ZoneRetrieve.ZoneRetrieve.state_id != null &&
      State.ZoneRetrieve.ZoneRetrieve.state_id != undefined
      // State.ZoneRetrieve.ZoneRetrieve.state_id.id != undefined
    ) {
      console.log(State.ZoneRetrieve.ZoneRetrieve, "editssss");
      let objectState = [];
      objectState.push({
        value: State.ZoneRetrieve.ZoneRetrieve.state_id.id,
        label: State.ZoneRetrieve.ZoneRetrieve.state_id.state_name,
      });
      SetStates(objectState);
      setDatas({
        ...datas,
        Zone: State.ZoneRetrieve.ZoneRetrieve.zone_name,
        description: State.ZoneRetrieve.ZoneRetrieve.description,

        state_id: State.ZoneRetrieve.ZoneRetrieve.state_id.id,
        region_id: State.ZoneRetrieve.ZoneRetrieve.region_id.id,
      });
      // console.log(SelectedStates, "asfsdf", datas);
    }
  }, [State.ZoneRetrieve.ZoneRetrieve.id]);

  const handleClose = () => {
    setShow(false);
  };
  const HandleChanges = (e) => {
    setDatas((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };
  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    setMuliselect1(selectedVal);
    setDatas({
      ...datas,
      region_id: selectedVal.value,
    });
  };

  ///---State------------
  const handleSelectChange = (selectedVal) => {
    setMuliselect(selectedVal);
    setDatas({
      ...datas,
      state_id: selectedVal.value,
    });
  };

  const [stateMul, setStateMul] = useState([]);
  const [regionSelected, setRegionMUl] = useState([]);
  const handleState = (sel) => {
    setStateMul(sel);
    SetStates(sel);
    setDatas({
      ...datas,
      state_id: sel.value,
    });
    // console.log(SelectedStates, "statesdassssss");
  };

  const handleRegionSelected = (sel) => {
    setRegionMUl(sel);
    setSlectRegions(sel);
    setDatas({
      ...datas,
      region_id: sel.value,
    });
  };

  //   ///----Region--------------------------
  //  useEffect(() => {
  //     const Datas = [];

  //     setRegion(state.regioncall.RegionDat);
  //     //console.log(state.regioncall.RegionDat.region_name ,"region 32432");
  //     if (state.regioncall.RegionDat != undefined) {
  //         let objectArray = [];
  //         state.regioncall.RegionDat.forEach((element) => {

  //             objectArray.push({ value: element.id, label: element.region_name });

  //         });

  //         setOptions2(objectArray);
  //     }
  // }, [])

  useEffect(() => {
    const Datas = [];

    setRegion(state.regioncall.RegionDat);
    // console.log(state.regioncall.RegionDat, "region 32432", datas.state_id);
    if (datas.state_id != undefined) {
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name,
          isDisabled: true,
        });
      });
      // console.log(objectArray, "regions listes");
      setOptions2(objectArray);
    }

    if (state.regioncall.RegionDat != undefined && datas.state_id != "") {
      console.log(datas.state_id, "state ids");
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name,
          isDisabled: false,
        });
      });

      setOptions2(objectArray);
      // console.log(nameList2, "namelist2");
    }
  }, [datas.state_id, state.regioncall.RegionDat , SearchedVal.regionSearch]);

  const HandleSubmit = () => {
    // console.log(datas);

    if (
      EditId == undefined ||
      EditId == "" ||
      !State.ZoneRetrieve.ZoneRetrieve.id
    ) {
      var a = 0;
      if (datas.Zone == "") {
        a = 1;
        setZoneError("*Zone is Required");
      }
      if (datas.region_id == "") {
        setRegionError("*Region is required");
        a = 1;
      }
      if (datas.description == "") {
        a = 1;
        setDescriptionError("*Description is Required");
      }
      if (datas.state_id == "") {
        setStateError("*State is required");
        a = 1;
      }
      if (a == 0) {
        console.log(datas, "inner");
        const payload = {
          datas: datas,
          currentPage: currentPage,
          state:stateID,
          region:regionID, 
          counts:3,
          search:search
        };

        dispatch(getZoneCreateActions(payload, setShow(false)));
      }
    }
  };
  const HandleSubmits = (e) => {
    e.preventDefault();
  };
  const HandleEdits = () => {
    if (
      EditId != undefined &&
      EditId != "" &&
      State.ZoneRetrieve.ZoneRetrieve.id
    ) {
      var a = 0;
      if (datas.Zone == "") {
        a = 1;
        setZoneError("*Zone is Required");
      }
      if (datas.description == "") {
        a = 1;
        setDescriptionError("*Description is Required");
      }
      if (datas.region_id == "") {
        setRegionError("*Region is required");
        a = 1;
      }
      if (datas.state_id == "") {
        setStateError("*State is required");
        a = 1;
      }
      if (datas.Zone !== "" && datas.description !== "") {
        const payload = {
          datas: datas,
          currentPage: currentPage,
          EditId: EditId,
          state:stateID,
          region:regionID, 
          counts:3,
          search:search
        };

        dispatch(setZoneEditActions(payload, props.setShow()));
      }
    }
  };

  return (
    <>
      <div className="RoleCreatePopup">
        <div className="BeforePopUp">
          <div className="RolePopups">
            <div className="asds">
              <div class="ModalHeader">
                {EditId == undefined || EditId == "" ? (
                  <span className="UserCreate">Zone  </span>
                ) : (
                  <span> Zone  </span>
                )}

                <div className="CloseIcon" onClick={(e) => setShow(false)}>
                  <CloseOutlinedIcon />
                </div>
              </div>

              <form
                class="row g-3 form-fields-wrapper"
                //onClick={HandleSubmits}
              >
                <div class="col-12 field-div">
                  <label
                    for="validationCustom01"
                    class="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    Zone Name
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    value={datas.Zone}
                    autoComplete="off"
                    onChange={(e) => {
                      HandleChanges(e);
                      setZoneError("");
                    }}
                    required
                    name="Zone"
                    style={{
                      padding: "10px",
                    }}
                  ></input>
                  <p style={{ color: "red", marginTop: "5px" }}>{ZoneError}</p>
                </div>

                <div class="col-12 field-div" style={{ marginBottom:"20px"}}>
                  <label
                    for="validationCustom02"
                    class="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    Description
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <textarea
                    type="text"
                    class="form-control"
                    autoComplete="off"
                    value={datas.description}
                    onChange={(e) => {
                      HandleChanges(e);
                      setDescriptionError("");
                    }}
                    name="description"
                    required
                    style={{
                      padding: "10px",
                    }}
                  ></textarea>
                  <p style={{ color: "red", marginTop: "5px" }}>
                    {DescriptionError}
                  </p>
                </div>

                {EditId == undefined || EditId == "" ? (
                  <>
                    {/* <div className="col-12 mt-5" id="RegionCreatePOPUP"> */}
                    <div className="col mt-5">

                      <label for="validationCustom01" class="form-label">
                        State 
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        className="Selects"
                        styles={{ position: "relative", top: "60px" }}
                        // options={options}
                        // onChange={handleChange}
                        onSelect={(e) => setMuliselect(e)}
                        onChange={(e) => {
                          handleSelectChange(e);
                          setStateError("");
                        }}
                        onInputChange={handleInputChange}
                        options={nameList}
                        labelledBy="Select"
                        
                      />
                      <p style={{ color: "red", marginTop: "5px" }}>
                        {stateerror}
                      </p>
                    </div>

                    {/* <div className="col-12 mt-5" id="RegionCreatePOPUP"> */}
                    <div className="col mt-5">

                      <label for="validationCustom01" class="form-label">
                        Region 
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        className="Selects"
                        styles={{ position: "relative", top: "60px" }}
                        // options={options}
                        // onChange={handleChange}
                        onSelect={(e) => setMuliselect1(e)}
                        onChange={(e) => {
                          handelRegionSlect(e);
                          setRegionError("");
                        }}
                        onInputChange={HandleRegionChanges}
                        options={nameList2}
                        labelledBy="Select"
                      />
                      <p style={{ color: "red", marginTop: "5px" }}>
                        {RegionError}
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    {EditId != undefined &&
                    EditId != "" &&
                    datas.state_id != null &&
                    datas.region_id != null &&
                    datas.region_id != "" &&
                    datas.state_id != "" ? (
                      <>
                        <div className="col mt-5">
                          <label for="validationCustom01" class="form-label">
                            State 
                          </label>
                          <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            // options={options}
                            // onChange={handleChange}
                            onSelect={(e) => setStateMul(e)}
                            onChange={(e) => {
                              handleState(e);
                              setStateError("");
                            }}
                            options={nameList}
                            value={SelectedStates}
                            labelledBy="Select"
                            onInputChange={handleInputChange}
                          />
                          <p className="Error">{stateerror}</p>
                        </div>

                        <div className="col mt-5">
                          <label for="validationCustom01" class="form-label">
                            Region 
                          </label>
                          <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            // options={options}
                            // onChange={handleChange}
                            onSelect={(e) => setRegionMUl(e)}
                            onChange={(e) => {
                              handleRegionSelected(e);
                              setRegionError("");
                            }}
                            options={nameList2}
                            value={SelectRegion}
                            onInputChange={HandleRegionChanges}
                            labelledBy="Select"
                          />
                          <p className="Error">{RegionError}</p>
                        </div>
                      </>
                    ) : (
                      <p style={{ marginLeft: "30px", color: "red" }}>
                        State is not defined
                      </p>
                    )}
                  </>
                )}
              </form>

              <div
                className="RoleButton"
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <button
                  class="btn  SaveBtn"
                  type="submit"
                  onClick={(e) => {
                    HandleSubmit(e);

                    HandleEdits(e);
                  }}
                >
                  Submit
                </button>

                <button class="btn CancelBtn" onClick={handleClose}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ZoneCreate;
